import {EVENT_PREFIX} from '../../../helpers';

export default (
  {
    field,
    instanceKey
  }) => (Object.assign({
  type: `${EVENT_PREFIX}_TOUCH_FIELD`
}, {field, instanceKey}));
